import { motion } from "framer-motion";

const testimonials = [
  {
    name: "John & Sam",
    text: "Thank you so much to all at The Fox. We had the most amazing day and night. Many guests stating it was the best wedding they had ever been to - quite a statement! Vikki was amazing, listened to what we wanted, understood our vision and was happy to accommodate all of our requests and suggestions. Nothing was too much trouble. The poor weather became a distant memory and certainly did not spoil our special day."
  },
  {
    name: "Guest",
    text: "A huge thank you to everyone at The Fox, it was the most wonderful day. The Fox is beautiful by day and magical at night. Every member of staff was polite and helpful, nothing was too much trouble. The food was excellent too. Thank you again for making it such a special day."
  },
  {
    name: "Jon & Emily",
    text: "Thank you so much The Fox Inn Stourton we had the best day that we could have ever dreamed of. Vicki, Lara and the team provided an absolutely phenomenal service, and nothing was too much to ask for leading up to and including our wedding day. Anyone that is considering the Fox as a venue for their wedding should definitely book with them. Again thank you so much to Vicki, Lara and the team for all your help."
  },
  {
    name: "Guest",
    text: "It was absolutely beautiful! We all enjoyed Em and Jon's special day so very much. A huge thank you to all at The Fox for your hard work, it was appreciated by us all. Incredibly friendly staff who couldn't do enough for us, it was by far the most wonderful wedding I've ever been to.. And everyone else who attended agrees. Thank you so much for making everything so perfect.. We have some plans for future family celebrations at The Fox!"
  }
];

export default function Testimonials() {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-screen px-8 md:px-12 lg:px-16 mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-8">What Our Couples Say</h2>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index} 
              className="p-6 bg-white shadow-lg rounded-2xl"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <p className="text-lg text-gray-600">“{testimonial.text}”</p>
              <p className="mt-4 font-semibold text-gray-800">- {testimonial.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}